var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dialogVisible
    ? _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("billingPage.position"),
            visible: _vm.dialogVisible,
            width: "750px",
            "before-close": _vm.handleCancel,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.form, inline: true } },
            [
              _c(
                "el-checkbox-group",
                {
                  staticClass: "flex-align flex-wrap",
                  model: {
                    value: _vm.checkList,
                    callback: function ($$v) {
                      _vm.checkList = $$v
                    },
                    expression: "checkList",
                  },
                },
                _vm._l(_vm.positionList, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticStyle: { width: "49%", margin: "0 0 10px 0" },
                    },
                    [
                      _c("el-checkbox", { attrs: { label: item.label } }),
                      _c("BjInputNumber", {
                        staticStyle: { width: "120px", "margin-left": "10px" },
                        attrs: {
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: item.percentage,
                          callback: function ($$v) {
                            _vm.$set(item, "percentage", $$v)
                          },
                          expression: "item.percentage",
                        },
                      }),
                    ],
                    1
                  )
                }),
                0
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleCancel } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSend } },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }